export default __webpack_public_path__ + "static/media/scratch11.f96fb895.mp3";